<template>
  <div class="container" v-if="loadingPageOver" :style="iosOrAndroidStyle">
    <w-nav-bar
      :icon="'iconchevron-left'"
      nav_title="电脑端制作简历"
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow"
    />
    <div class="mobile-page-container">
      <img src="https://files.wondercv.com/%E7%94%B5%E8%84%91%E7%AB%AF%E5%88%B6%E4%BD%9C%E7%AE%80%E5%8E%86.png"
           class="content-img">
    </div>
  </div>
</template>
<script>
	import { envMixin } from '@/assets/js/mixin/global'
  import WNavBar from "@/components/global/w-navbar";
	export default {
		mixins: [ envMixin ],
		head () {
			return {
				title: '电脑端制作简历'
			}
		},
		data () {
			return {}
		},
		methods: {
			leftBtnClick() {
      this.$router.back();
    },
		},
		components: {
			WNavBar
		}
	}

</script>
<style lang="scss" scoped>
  .container {
    height: 100vh;
    background: #fff;
    font-family: PingFangSC-Regular;
  }
  .mobile-page-container {
    margin-top: 0px;
    padding-top: 70px;
  }
  .content-img {
    width: 100%;
    display: block;
    margin: 0 auto;
    // margin-top: 70px;
    margin-bottom: calc(60px + env(safe-area-inset-bottom)) !important;
  }
</style>
